import HARDCODE from '../../business-const/HardCode/HardCode'



const protecaoList = [
    {
       id: 'EstudoFormProtecaoSugeridaClienteConjuge',
    },
    {
        id: HARDCODE.analisePatrimonialChart,
    },
    {
        id: 'EstudoFormSucessaoVitalicia',
    },
    {
        id: 'ProjecaoSucessaoVitaliciaChart',
    },
    {
        id: 'DespesasAcumuladasChart',
    },
    {
        id: 'EstudoFormDespesasPanelRadioGroup',
    },
    {
        id: 'EstudoFormGarantiasPanelRadioGroup',
    },
    {
        id: 'EstudoReportResumoNecessidadeProtecao',
    },
 ]
  
 export default protecaoList